
import { BsTwitter } from 'react-icons/bs'
import { SiDiscord } from 'react-icons/si'
import { SiTiktok } from 'react-icons/si'
import { ContainerHeader, Content } from './styles'
export function Header() {
    return(
        <ContainerHeader>
            <Content>
            <ul>
                <li>
                    <a href="https://bit.ly/3M0ik7A" target="_blank" rel="noreferrer"> 
                        <BsTwitter />
                        <span>
                            TWITTER
                        </span>
                    </a>
                </li>
                <li>
                    <a href="http://bit.ly/3KI0Nkh" target="_blank" rel="noreferrer"> 
                        <SiDiscord />
                        <span>
                            DISCORD
                        </span>
                    </a>
                </li>
                <li>
                    <a href="https://bit.ly/3uG9hTG" target="_blank" rel="noreferrer">
                        <SiTiktok />
                        <span>
                            TIKTOK
                        </span>
                    </a>
                </li>
            </ul>
            </Content>
        </ContainerHeader>
    )
}